import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { link, paragraphSmall } from '@helpers/typography';
import SectionWrapper, { ContentType, } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionSpacing: ${fluid(6, 12)};
  --sectionSpacingTop: var(--sectionSpacing);
  --sectionSpacingBottom: var(--sectionSpacing);
  --sectionColour: ${brand.blue.dark};
  --separatorColour: ${brand.green.default};

  position: relative;
  z-index: 2; // Ensure breadcrumbs are above the following skip link

  &[data-type=${ContentType.Intermediaries}] {
    --separatorColour: ${brand.green.dark};
  }

  &[data-type=${ContentType.Savings}] {
    --separatorColour: ${brand.blue.default};
  }
`;
const List = styled.ul `
  ${paragraphSmall};

  color: var(--sectionColour);
  width: 100%;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Item = styled.li `
  display: inline;
  margin-right: 12px;

  span {
    margin-left: 12px;
  }

  svg {
    display: block;
    width: ${fluid(12, 14)};
    transform: rotate(-90deg);
    color: var(--separatorColour);
  }

  &:has(a[aria-current='page']) {
    margin-right: 0;
  }

  @media ${until(Device.TabletLarge)} {
    &[data-hidden='true'] {
      ${srOnly};
    }
  }

  @media ${from(Device.TabletLarge)} {
    &[data-mobile] {
      display: none;
    }
  }
`;
const ItemLink = styled.a `
  ${link};

  display: inline;
  white-space: nowrap;
  line-height: 24px;
  padding: 3px 0; // Ensure click area is at least 24px high
  text-decoration-color: transparent;

  &:not([aria-current='page']):focus-visible,
  &:not([aria-current='page']):hover {
    text-decoration-color: currentColor;
  }
`;
const BreadcrumbsStyles = {
    Container,
    List,
    Item,
    ItemLink,
};
export default BreadcrumbsStyles;
